import React from 'react';

import { useAccountRoles } from 'hooks/EntityTypes/useAccountRoles';
import { useCurrentUser, useWorkspaceContext } from 'hooks/common';
import { useAccountByID } from './useAccountByID';
import { useAccountUsers } from './useAccountUsers';

export const useCurrentUserAccount = () => {
  const { currentUserID } = useCurrentUser();
  const { idMap: accountRolesIdMap, isLoading: isLoadingAccountRoles } =
    useAccountRoles();
  const { getWorkspace } = useWorkspaceContext();
  const workspace = getWorkspace();

  const {
    accountIDbyUserIdMap,
    accountUsers,
    isLoading: isLoadingAccountUser,
  } = useAccountUsers(workspace?.attributes.accountID);

  const { account, isLoading: isLoadingAccount } = useAccountByID(
    accountIDbyUserIdMap?.[currentUserID || '']
  );

  const currentUserAccountRoleID = React.useMemo(() => {
    return accountUsers?.find(
      (accountUser) => accountUser.attributes.userID === currentUserID
    )?.attributes.accountRoleID;
  }, [accountUsers, currentUserID]);

  const isAdmin = React.useMemo(() => {
    return (
      accountRolesIdMap?.[currentUserAccountRoleID || '']?.attributes.name ===
        'Admin' || false
    );
  }, [accountRolesIdMap, currentUserAccountRoleID]);

  const isLoading =
    isLoadingAccountUser || isLoadingAccount || isLoadingAccountRoles;

  return { isLoading, isAdmin, account };
};
